// 每日名言统一数据源（原分散在 Home.vue / Hot.vue 中，现已抽离到此文件）
// 每条名言包含英文(en)与中文(zh)两部分

export const QUOTES = [
  { en: 'Aim for the moon. If you miss, you may hit a star.', zh: '把月亮作为你的目标。如果你没打中，也许你还能打中星星' },
  { en: "A man's best friends are his ten fingers.", zh: '人最好的朋友是自己的十个手指' },
  { en: 'Behind every beautiful life, there has been some kind of pain.', zh: '破茧成蝶的美好生活都有伤痛' },
  { en: 'Do not give in to fear.', zh: '别在恐惧面前低下你的头' },
  { en: 'Do not find excuses for failure, to chase success reasons.', zh: '不要找失败的借口，去追成功的理由' },
  { en: 'Everyone there is a part of the living for others their own.', zh: '每个人都存在着那部分为别人而活的自己' },
  { en: 'Every day is beautiful if you choose to see it.', zh: '如果你愿意去发现，其实每一天都很美' },
  { en: 'Flat rich prosperous time in vain to develop a group of coward, hardship is the mother of strong forever.', zh: '平富足的盛世徒然养成一批懦夫，困苦永远是坚强之母' },
  { en: 'Have faith in your dreams and someday your rainbow will come smiling through.', zh: '请对梦想充满信心，总有一天属于你的彩虹会在天空微笑' },
  { en: 'I am the luckiest person in the world.', zh: '我是世界上最幸运的人' },
  { en: 'I lose, I lose, but I never give up.', zh: '我输过,我败过,但我从未放弃过' },
  { en: 'If you get tired, learn to rest, not to quit.', zh: '如果你累了，学会休息，而不是放弃' },
  { en: "If you don't try, you'll never know. So try.", zh: '如果你不去试，你永远也不知道结果，所以去试试吧' },
  { en: 'If you never chase your dream, you will never catch them.', zh: '若不去追逐梦想，你将永远无法抓住梦想' },
  { en: 'Judge each day not by the harvest you reap but by the seeds you plant.', zh: '不要问自己收获了多少果实，而是要问自己今天播种了多少种子' },
  { en: 'Love understands love; it needs no talk.', zh: '相爱的心息息相通，无需用言语倾诉' },
  { en: 'Like a child, always believe in hope, I believe the dream.', zh: '像孩子一样，永远相信希望，相信梦想' },
  { en: 'Life is never easier, we just get stronger.', zh: '生活从未变得容易，只是我们变得更加坚强' },
  { en: 'Misery can be caused by someone being just weak and indecisive.', zh: '一个人仅仅因为软弱无能或优柔寡断就完全可能招致痛苦' },
  { en: 'May there be enough clouds in your life to make a beautiful sunset.', zh: '愿你生命中有够多的云翳，来造成一个美丽的黄昏' },
  { en: 'No matter how you feel, get up, dress up and fight for your dreams.', zh: '无论你现在感觉如何，请起床、穿好衣服然后为你的梦想而奋斗' },
  { en: 'Nothing in the world is difficult if you put your heart into it.', zh: '世上无难事，只怕有心人' },
  { en: 'No one can change another. But one can be the reason for another to change.', zh: '没人能改变另一个人，但是某个人能成为一个人改变的原因' },
  { en: 'Only his strong enough, will not be trampled.', zh: '只有自己足够强大，才不会被别人践踏' },
  { en: 'People are not just to love and live.', zh: '人不是仅仅为了爱而生存的' },
  { en: "People do a lot of thinking, and sometimes, that's what kills us.", zh: '有时候是我们自己想太多才让自己如此难受' },
  { en: 'Put blinders on to those things that conspire to hold you back, especially the ones in your own head.', zh: '不要去想那些阻碍你的事，尤其是那些自己想象出来的事' },
  { en: "Remember happiness doesn't depend upon who you are or what you have; it depends solely on what you think.", zh: '幸福不在于你是谁，你拥有什么，而仅仅在于你自己怎么看待' },
  { en: 'Sometimes, you have to make your own happy ending.', zh: '有时候，只能靠自己书写自己的美好结局' },
  { en: 'Stop to have a rest, do not forget others still in the running.', zh: '停下来休息的时候，不要忘记别人还在奔跑' },
  { en: 'This moment is your life.', zh: '活在当下' },
  { en: 'To do the useful thing, to say the courageous thing, to contemplate the beautiful thing: that’s enough for one man’s life.', zh: '做有用的事，说勇敢的话，想美好的事，一生足矣' },
  { en: 'Time and experience heals pain.', zh: '时间和经历会抚平一切伤痛' },
  { en: 'Turn your face to the sun and the shadows fall behind you.', zh: '永远面向阳光，这样你就看不见阴影了' },
  { en: 'The greatest test of courage on earth is to bear defeat without losing heart.', zh: '世界上对勇气的最大考验是忍受失败而不丧失信心' },
  { en: 'The worst sort of indolence is being given a choice, yet taking no initiative to change.', zh: '我们人生中最大的懒惰，就是当我们明知自己拥有作出选择的能力，却不去主动改变而是放任它的生活态度' },
  { en: 'The world is like a mirror: Frown at itand it frowns at you; smile, and it smiles too.', zh: '世界犹如一面镜子：朝它皱眉它就朝你皱眉，朝它微笑它也吵你微笑' },
  { en: 'To the path of timber, iron and steel will never regret bright spray of molten steel was abandoned.', zh: '为了走上成材的道路，钢铁决不惋惜璀璨的钢花被遗弃' },
  { en: 'The questions you ask determine the quality of your life.', zh: '你生活的品质取决于你所提出的问题' },
  { en: "We'd better struggle for the future rather than regret for the past.", zh: '如果后悔过去，不如奋斗将来' },
  { en: 'Your dream is like a flower. if you water it patiently, the flower will come out beautifully.', zh: '即使是最简单的梦想，用心浇灌，也能开出绚烂的花' },
  { en: 'You see what you believe.', zh: '一个人相信什么，就会看见什么' },
]

/**
 * 根据天数自动切换每日名言
 * @param {number} [day] 以「天」为单位的整数，缺省则取当前日期
 * @returns {{en:string, zh:string}}
 */
export function getDailyQuote(day) {
  const d = day ?? Math.floor(Date.now() / (1000 * 60 * 60 * 24))
  return QUOTES[d % QUOTES.length]
}
